import React, { useEffect, useState } from "react";

import { Button } from "Components/atoms/Button";
import { DatePickerWithInputMobile } from "Components/molecules/DatePickerWithInput/Mobile";
import { useCalendarContext } from "shared/contexts/CalendarContext";

import {
  FieldSearchContentMobile,
  FieldSearchHeaderMobile,
  FieldSearchMobile,
} from "./styles";
// @ts-ignore
import { ReactComponent as CalendarGoingSvg } from "assets/svgs/calendar-going.svg";
import { ReactComponent as CalendarBackSvg } from "assets/svgs/calendar-back.svg";
import { FaArrowLeft } from "react-icons/fa";
import { useGeneralContext } from "shared/contexts/GeneralContext";
import { useSearchContext } from "shared/contexts/SearchContext";
import { orderDatesAsc } from "shared/utils/dates";
import { Modal } from "../../Modal/Mobile";
import { DatePickerActions } from "Components/atoms/DatePickerActions/Mobile";
import { DataSearchOriginMobile } from "./Origin";
import { DataSearchMobileProps } from "./types";

export const DataSearchMobile: React.FC<DataSearchMobileProps> = ({
  type,
  isVisibel,
}) => {
  const {
    daysInMonth,
    selectedDestinationDates,
    selectedOriginDates,
    setSelectedOriginDates,
    setSelectedDestinationDates,
    setShowOriginCalendarPickerMobile,
    setShowDestinationCalendarPickerMobile,
  } = useCalendarContext();
  const { setIsHeaderVisible } = useGeneralContext();
  const { setDepartureDates, setReturnDates, searchState } = useSearchContext();

  const isDisabled =
    searchState.tripType === "oneWay" && type === "destination";

  const handleSetDepartureDates = (dates: string[]) => {
    const newDates = orderDatesAsc(dates);
    setSelectedOriginDates(newDates);
    setDepartureDates(newDates);
  };

  const handleSetDestinationDates = (dates: string[]) => {
    const newDates = orderDatesAsc(dates);
    setSelectedDestinationDates(newDates);
    setReturnDates(newDates);
  };

  useEffect(() => {
    setSelectedOriginDates(searchState?.departureDates ?? []);
    setDepartureDates(searchState?.departureDates ?? []);
  }, [searchState.departureDates]);

  useEffect(() => {
    setSelectedDestinationDates(searchState?.returnDates ?? []);
    setReturnDates(searchState?.returnDates ?? []);
  }, [searchState.returnDates]);

  const handleIsVisible = () => {
    type === "origin"
      ? setShowOriginCalendarPickerMobile(false)
      : setShowDestinationCalendarPickerMobile(false);
  };

  useEffect(() => {
    setIsHeaderVisible(!isVisibel);
  }, [isVisibel, setIsHeaderVisible]);

  return (
    <>
      <Modal isVisibleModal={isVisibel} onClose={handleIsVisible}>
        <DataSearchOriginMobile type={type} />
      </Modal>

      <FieldSearchContentMobile
        isVisible={isVisibel}
        style={{
          position: isDisabled ? "relative" : isVisibel ? "fixed" : "inherit",
        }}
      >
        {isDisabled && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 10,
              pointerEvents: "none",
            }}
          />
        )}
        <FieldSearchHeaderMobile isVisible={isVisibel}>
          <Button
            color="white"
            size="ghost"
            icon={<FaArrowLeft />}
            onClick={handleIsVisible}
          />

          <FieldSearchMobile isVisible={isVisibel}>
            <DatePickerWithInputMobile
              title={`Selecione até 4 datas de ${type === "origin" ? "ida" : "volta"}`}
              placeholder={`${type === "origin" ? "Ida" : "Volta"}`}
              maxSelectableDates={4}
              daysInMonth={daysInMonth}
              selectedDates={
                type === "origin"
                  ? selectedOriginDates || []
                  : selectedDestinationDates || []
              }
              onDatesChange={
                type === "origin"
                  ? handleSetDepartureDates
                  : handleSetDestinationDates
              }
              isVisible={isVisibel}
              type={type}
              onConfirmAction={handleIsVisible}
              icon={
                type === "origin" ? (
                  <CalendarGoingSvg width={10} height={10} />
                ) : (
                  <CalendarBackSvg width={10} height={10} />
                )
              }
              isDisabled={isDisabled}
              onClick={() =>
                type === "origin"
                  ? setShowOriginCalendarPickerMobile(true)
                  : setShowDestinationCalendarPickerMobile(true)
              }
            />
          </FieldSearchMobile>
        </FieldSearchHeaderMobile>
      </FieldSearchContentMobile>
    </>
  );
};
